module.exports = __webpack_public_path__ + "img/virus-slash.64339b33.svg";